import React from 'react'
import { Field } from 'redux-form'
import { compose } from 'recompose'

import { translate, forms } from 'parking-react-common'

import { routing, parkingLots } from '../redux'

import form from '../components/Form'
import Panel from '../components/Panel'
import MapPolygonsField from '../components/MapPolygonsField'
import FormContainer from '../components/FormContainer'
import FormButtons from '../components/FormButtons'

const ParkingLotMapForm = (props) => {
    const { currentValues, initialValues, t } = props
    const bounds = parkingLots.getLocationBounds(initialValues)

    return (
        <Panel title={ t('Location') } hasTable>
            <FormContainer>
                <Field
                    name="polygons"
                    component={ MapPolygonsField }
                    bounds={ bounds }
                    color={ initialValues.color }
                    isHorizontal
                />
                <FormButtons
                    onCancel={ () => {
                        routing.push(routing.routeFor('parkingLots', {
                            id     : currentValues.id,
                            tab    : 'location',
                            action : null
                        }))
                    } }
                    { ...props }
                />
            </FormContainer>
        </Panel>
    )
}

ParkingLotMapForm.propTypes = forms.propTypes

export default compose(
    translate(),
    form({ id: forms.parkingLot.id })
)(ParkingLotMapForm)
